import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { 
  Newspaper, Calendar, X, ChevronLeft, ChevronRight,
  ZoomIn, ArrowRight
} from 'lucide-react';
import { Button } from '../components/ui/button';
import { Card, CardContent } from '../components/ui/card';
import { Badge } from '../components/ui/badge';
import {
  Dialog,
  DialogContent,
} from '../components/ui/dialog';

const mediaItems = [
  {
    id: 1,
    image: "https://customer-assets.emergentagent.com/job_govit-connect/artifacts/756jdpwh_p1.jpeg",
    title: "टैक्स वसूली तेज करने उतरी एनएसटीयू कंपनी",
    description: "पहले दिन 482 प्रॉपर्टी टैक्स बिल किए वितरित। 50 हजार बिल बांटने का जिम्मा, हर बिल की हो रही प्रॉपर्टी टैक्स पोर्टल से क्रॉस वेरिफिकेशन। 15 कर्मचारियों को कंपनी ने फील्ड में उतारा।",
    source: "दैनिक जागरण - कुरुक्षेत्र",
    date: "2026"
  },
  {
    id: 2,
    image: "https://customer-assets.emergentagent.com/job_govit-connect/artifacts/8lnspjfc_p2.jpeg",
    title: "थानेसर नप ने लगाया शिविर, 54 हजार टैक्स की रिकवरी",
    description: "एनएसटीयू कंपनी ने अब तक 16 हजार से अधिक प्रॉपर्टी टैक्स रिकवरी बिलों का वितरण किया है। पहले शिविर में 54 हजार रुपये की राशि की रिकवरी हुई है।",
    source: "दैनिक जागरण - कुरुक्षेत्र",
    date: "2026"
  },
  {
    id: 3,
    image: "https://customer-assets.emergentagent.com/job_govit-connect/artifacts/xhio32t7_p3.jpeg",
    title: "अब लाडवा में भी प्रॉपर्टी टैक्स के बिल घर-घर पहुंचाएगी नपा",
    description: "लाडवा नगर पालिका ने इसका टेंडर एनएसटीयू इंडिया प्राइवेट लिमिटेड कंपनी को अलॉट कर दिया है। कंपनी को 15 हजार 967 बिल वितरित करने होंगे।",
    source: "दैनिक जागरण - लाडवा",
    date: "2026"
  },
  {
    id: 4,
    image: "https://customer-assets.emergentagent.com/job_govit-connect/artifacts/yl3f5yh2_p4.jpeg",
    title: "पिहोवा में घर-घर पहुंचाया जाएगा प्रॉपर्टी टैक्स बिल",
    description: "पिहोवा नपा ने एनएसटीयू इंडिया प्राइवेट लिमिटेड कंपनी को नियुक्त किया है। कंपनी ने 15 दिन में 19 हजार 521 प्रॉपर्टी टैक्स बिल वितरित करने का लक्ष्य रखा है।",
    source: "दैनिक जागरण - पिहोवा",
    date: "2026"
  },
  {
    id: 5,
    image: "https://customer-assets.emergentagent.com/job_govit-connect/artifacts/tmv92c0j_p5.jpeg",
    title: "फर्म ने काम किया शुरू, बिल वितरण के साथ वार्डों में शिविर लगाकर दुरुस्त की जाएंगी त्रुटियां",
    description: "हाउस टैक्स बिल वितरण - नप का अटका 10 करोड़ से अधिक टैक्स, अब जगी अच्छी रिकवरी की संभावना। फर्म एनएसटीयू इंडिया प्राइवेट लिमिटेड को वर्क ऑर्डर जारी।",
    source: "दैनिक भास्कर - कुरुक्षेत्र",
    date: "13-01-2026"
  },
  {
    id: 6,
    image: "https://customer-assets.emergentagent.com/job_govit-connect/artifacts/1lwkkry5_p10.jpeg",
    title: "नप के हाउस टैक्स बिलों का डोर-टू-डोर वितरण",
    description: "NSTU India द्वारा हाउस टैक्स बिलों का डोर-टू-डोर वितरण - फर्म ने 15 कर्मचारी उतारे",
    source: "दैनिक भास्कर - कुरुक्षेत्र",
    date: "17-01-2026"
  },
  {
    id: 7,
    image: "https://customer-assets.emergentagent.com/job_govit-connect/artifacts/g5xwxip8_p9.jpeg",
    title: "पिहोवा नपा में प्रॉपर्टी टैक्स बिलों का वितरण शुरू",
    description: "19,521 बिल बंटेंगे, टैक्स भुगतान को फिर लगेंगे वार्डों में कैंप - NSTU India Private Limited",
    source: "दैनिक भास्कर - कुरुक्षेत्र",
    date: "08-03-2026"
  },
  {
    id: 8,
    image: "https://customer-assets.emergentagent.com/job_govit-connect/artifacts/nvnt2qjg_p8.jpeg",
    title: "नपा की प्राइवेट फर्म विभिन्न वार्ड में बांटेगी बिल",
    description: "15,967 प्रॉपर्टी के हाउस टैक्स बिलों का होगा वितरण - NSTU India की जिम्मेदारी",
    source: "दैनिक भास्कर - कुरुक्षेत्र",
    date: "10-02-2026"
  },
  {
    id: 9,
    image: "https://customer-assets.emergentagent.com/job_govit-connect/artifacts/8xbn6g1s_p7.jpeg",
    title: "वार्ड-13 में लगे कैंप में 1.14 लाख टैक्स रिकवर",
    description: "50 प्रॉपर्टी सेल्फ सर्टिफाइड - NSTU India Private Limited फर्म के कर्मचारियों ने प्रॉपर्टी को ऑनलाइन पोर्टल पर स्वयं सत्यापित कराने में सहयोग किया",
    source: "दैनिक भास्कर - कुरुक्षेत्र",
    date: "04-02-2026"
  },
  {
    id: 10,
    image: "https://customer-assets.emergentagent.com/job_govit-connect/artifacts/r6s1m4yo_p6.jpeg",
    title: "नगर परिषद की वार्डों में हाउस टैक्स जमा कराने की व्यवस्था",
    description: "पहले कैंप में 54 हजार की रिकवरी - NSTU India Private Limited फर्म के कर्मचारियों ने प्रॉपर्टी को ऑनलाइन NDCC पोर्टल पर स्वयं सत्यापित कराने में सहयोग किया",
    source: "दैनिक भास्कर - कुरुक्षेत्र",
    date: "03-02-2026"
  }
];

export default function MediaCoverage() {
  const [selectedImage, setSelectedImage] = useState(null);
  const [currentIndex, setCurrentIndex] = useState(0);

  const openLightbox = (index) => {
    setCurrentIndex(index);
    setSelectedImage(mediaItems[index]);
  };

  const closeLightbox = () => {
    setSelectedImage(null);
  };

  const goToPrevious = () => {
    const newIndex = currentIndex === 0 ? mediaItems.length - 1 : currentIndex - 1;
    setCurrentIndex(newIndex);
    setSelectedImage(mediaItems[newIndex]);
  };

  const goToNext = () => {
    const newIndex = currentIndex === mediaItems.length - 1 ? 0 : currentIndex + 1;
    setCurrentIndex(newIndex);
    setSelectedImage(mediaItems[newIndex]);
  };

  return (
    <div data-testid="media-coverage-page">
      {/* Hero Section */}
      <section className="relative py-20 bg-nstu-green-800" data-testid="media-hero">
        <div className="max-w-7xl mx-auto px-4 md:px-8">
          <div className="max-w-3xl">
            <div className="flex items-center gap-3 mb-6">
              <Newspaper className="w-10 h-10 text-nstu-gold-400" />
              <Badge className="bg-nstu-gold-400 text-nstu-green-900 text-lg px-4 py-1">Press Coverage</Badge>
            </div>
            <h1 className="font-heading text-4xl md:text-5xl font-bold text-white mb-6">
              Media Coverage & News
            </h1>
            <p className="text-gray-300 text-lg mb-8">
              NSTU India's work recognized by leading newspapers. Our government IT projects 
              and citizen service initiatives featured in Dainik Bhaskar and other publications.
            </p>
          </div>
        </div>
      </section>

      {/* Stats */}
      <section className="py-12 bg-white border-b" data-testid="media-stats">
        <div className="max-w-7xl mx-auto px-4 md:px-8">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8 text-center">
            <div>
              <div className="font-heading text-4xl font-bold text-nstu-green-800">10+</div>
              <p className="text-gray-600">News Features</p>
            </div>
            <div>
              <div className="font-heading text-4xl font-bold text-nstu-green-800">50K+</div>
              <p className="text-gray-600">Bills Distributed</p>
            </div>
            <div>
              <div className="font-heading text-4xl font-bold text-nstu-green-800">₹1.14L+</div>
              <p className="text-gray-600">Tax Recovered</p>
            </div>
            <div>
              <div className="font-heading text-4xl font-bold text-nstu-green-800">4+</div>
              <p className="text-gray-600">Cities Covered</p>
            </div>
          </div>
        </div>
      </section>

      {/* Gallery Grid */}
      <section className="py-20 bg-gray-50" data-testid="media-gallery">
        <div className="max-w-7xl mx-auto px-4 md:px-8">
          <div className="text-center mb-16">
            <Badge className="bg-nstu-green-100 text-nstu-green-800 mb-4">Featured In</Badge>
            <h2 className="font-heading text-3xl md:text-4xl font-bold text-nstu-green-800 mb-4">
              Newspaper Coverage Gallery
            </h2>
            <p className="text-gray-600 max-w-2xl mx-auto">
              Our work in property tax bill distribution and citizen services featured in Dainik Bhaskar
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {mediaItems.map((item, index) => (
              <Card 
                key={item.id}
                className="group overflow-hidden border-0 shadow-lg card-hover cursor-pointer"
                onClick={() => openLightbox(index)}
                data-testid={`media-item-${item.id}`}
              >
                <div className="relative aspect-[3/4] overflow-hidden bg-gray-100">
                  <img 
                    src={item.image}
                    alt={item.title}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  />
                  <div className="absolute inset-0 bg-black/0 group-hover:bg-black/30 transition-colors flex items-center justify-center">
                    <ZoomIn className="w-12 h-12 text-white opacity-0 group-hover:opacity-100 transition-opacity" />
                  </div>
                  <div className="absolute top-4 left-4">
                    <Badge className="bg-orange-500 text-white font-semibold">
                      दैनिक भास्कर
                    </Badge>
                  </div>
                </div>
                <CardContent className="p-6">
                  <div className="flex items-center gap-2 text-sm text-gray-500 mb-3">
                    <Calendar className="w-4 h-4" />
                    <span>{item.date}</span>
                  </div>
                  <h3 className="font-heading text-lg font-bold text-nstu-green-800 mb-2 line-clamp-2">
                    {item.title}
                  </h3>
                  <p className="text-gray-600 text-sm line-clamp-2">
                    {item.description}
                  </p>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>
      </section>

      {/* Lightbox Dialog */}
      <Dialog open={!!selectedImage} onOpenChange={closeLightbox}>
        <DialogContent className="max-w-4xl p-0 bg-black border-0 overflow-hidden">
          {selectedImage && (
            <div className="relative">
              {/* Close button */}
              <button 
                onClick={closeLightbox}
                className="absolute top-4 right-4 z-50 w-10 h-10 rounded-full bg-black/50 flex items-center justify-center text-white hover:bg-black/70 transition-colors"
                data-testid="lightbox-close"
              >
                <X className="w-6 h-6" />
              </button>

              {/* Navigation buttons */}
              <button 
                onClick={goToPrevious}
                className="absolute left-4 top-1/2 -translate-y-1/2 z-50 w-12 h-12 rounded-full bg-black/50 flex items-center justify-center text-white hover:bg-black/70 transition-colors"
                data-testid="lightbox-prev"
              >
                <ChevronLeft className="w-8 h-8" />
              </button>
              <button 
                onClick={goToNext}
                className="absolute right-4 top-1/2 -translate-y-1/2 z-50 w-12 h-12 rounded-full bg-black/50 flex items-center justify-center text-white hover:bg-black/70 transition-colors"
                data-testid="lightbox-next"
              >
                <ChevronRight className="w-8 h-8" />
              </button>

              {/* Image */}
              <div className="max-h-[80vh] overflow-auto">
                <img 
                  src={selectedImage.image}
                  alt={selectedImage.title}
                  className="w-full h-auto"
                />
              </div>

              {/* Caption */}
              <div className="p-6 bg-white">
                <div className="flex items-center gap-2 text-sm text-gray-500 mb-2">
                  <Badge className="bg-orange-500 text-white text-xs">
                    {selectedImage.source}
                  </Badge>
                  <span>•</span>
                  <Calendar className="w-4 h-4" />
                  <span>{selectedImage.date}</span>
                </div>
                <h3 className="font-heading text-xl font-bold text-nstu-green-800 mb-2">
                  {selectedImage.title}
                </h3>
                <p className="text-gray-600">
                  {selectedImage.description}
                </p>
              </div>
            </div>
          )}
        </DialogContent>
      </Dialog>

      {/* CTA Section */}
      <section className="py-16 bg-nstu-green-800" data-testid="media-cta">
        <div className="max-w-4xl mx-auto px-4 md:px-8 text-center">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-white mb-4">
            Want to Feature Our Work?
          </h2>
          <p className="text-gray-300 mb-8">
            For media inquiries and press coverage, contact our communications team
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link to="/contact">
              <Button size="lg" className="bg-nstu-gold-400 text-nstu-green-900 hover:bg-nstu-gold-300 font-semibold btn-lift">
                Contact Us
                <ArrowRight className="w-4 h-4 ml-2" />
              </Button>
            </Link>
            <Link to="/government-projects">
              <Button size="lg" variant="outline" className="border-white text-white hover:bg-white hover:text-nstu-green-800">
                View Our Projects
              </Button>
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}
